import React from "react";

import {FooterContainer} from './footer.styles'
const Footer = () => (
    <FooterContainer>
        2022 Houser, Inc.
    </FooterContainer>
)
export default Footer